import { Provider, Type } from '@angular/core';
import { RouteProviderService } from '../providers/route-provider.service';

export const provideRoutes = (
  provider: Type<RouteProviderService>,
): Provider => ({
  provide: RouteProviderService,
  useClass: provider,
});
